module.exports = __webpack_public_path__ + "static/media/group_default_cropped.fcf946b6.jpg";